export default __webpack_public_path__ + "static/loginMeta-6daf349e93a4027111e093fbfa591d07.jpg";